import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { GET_ITEM_LIMIT } from "constants/constants"
import { RootState } from "store/store"

interface BaseXLSForm {
  pageSize: number
  pageNumber: number
  skip: number
  top: number
}

const initialState: BaseXLSForm = {
  pageSize: GET_ITEM_LIMIT,
  pageNumber: 1,
  skip: 0,
  top: GET_ITEM_LIMIT,
}

const baseXlsFormSlice = createSlice({
  name: "baseXlsForm",
  initialState,
  reducers: {
    setPageNumber: (state, action: PayloadAction<number>) => {
      state.pageNumber = action.payload
    },
    setTop: (state, action: PayloadAction<number>) => {
      state.top = action.payload
    },
  },
})

export const { setPageNumber, setTop } = baseXlsFormSlice.actions
export default baseXlsFormSlice.reducer

export const getPageNumber = (state: RootState) => state.baseXlsForm.pageNumber
export const getTop = (state: RootState) => state.baseXlsForm.top
export const getSkip = (state: RootState) => {
  const { pageNumber, top } = state.baseXlsForm
  return pageNumber === 1 ? 0 : (pageNumber - 1) * top
}
